import client from './SharedConfig';

export const contactUs = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'advertisement/contact/msg/',
        data: body
    };
    return client.request(config )
};